"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialContentService = void 0;
var feed_service_1 = require("./feed.service");
var reactions_service_1 = require("./reactions.service");
var topics_service_1 = require("./topics.service");
var SocialContentService = /** @class */ (function () {
    function SocialContentService(groupId, context) {
        this.feed = new feed_service_1.FeedService(groupId, context);
        this.reactions = new reactions_service_1.ReactionsService(groupId, context);
        this.topics = new topics_service_1.TopicsService(groupId, context);
    }
    return SocialContentService;
}());
exports.SocialContentService = SocialContentService;
//# sourceMappingURL=social-content.service.js.map